/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfsam_PriceInputs */

const en_pc_alt_t_pdfsam_price = /** @type {(inputs: Pc_Alt_T_Pdfsam_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free (Basic edition)`)
};

const zh_pc_alt_t_pdfsam_price = /** @type {(inputs: Pc_Alt_T_Pdfsam_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费（Basic 版）`)
};

/**
* | output |
* | --- |
* | "Free (Basic edition)" |
*
* @param {Pc_Alt_T_Pdfsam_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfsam_price = /** @type {((inputs?: Pc_Alt_T_Pdfsam_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfsam_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfsam_price(inputs)
	return zh_pc_alt_t_pdfsam_price(inputs)
});
export { pc_alt_t_pdfsam_price as "pc.alt.t.pdfsam.price" }